import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ValidationErrors } from 'constants/validations';
import { Col, Select, Form, FormModal } from 'components';
import { useBrandSelectListQuery, useLeadByIdQuery } from 'api';
import { useAccessControl } from '../../../../components/common/accessControl/useAccessControl';
import { PERMISSIONS } from '../../../../constants/permissions';

interface AddBrandToLeadModalProps {
  form: any;
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  setOpenBrandModal: () => void;
}

export const AddBrandToLead: React.FC<AddBrandToLeadModalProps> = ({
  form,
  open,
  onSubmit,
  onCancel,
  setOpenBrandModal,
}) => {
  const { hasAccess } = useAccessControl();
  const { id } = useParams() as { id: string };
  const { data: { brandIds = {} } = {} } = useLeadByIdQuery({ id }, { skip: !id });
  const { data = [] } = useBrandSelectListQuery();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [form, open]);

  const options = useMemo(() => {
    const selectedBrands = Object.keys(brandIds);
    return data.map((i: { id: string }) => {
      return { ...i, disabled: selectedBrands.includes(i.id) };
    });
  }, [brandIds, data]);

  return (
    <FormModal
      form={form}
      title="Add Brand To Lead"
      width={400}
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      okText="Add"
    >
      <Col span={24}>
        <Form.Item
          name="brandId"
          label="Brands*"
          rules={[{ required: true, message: ValidationErrors.required('Brand') }]}
        >
          <Select
            size="large"
            showAdd={hasAccess(PERMISSIONS.brands.brand.write)}
            onAdd={setOpenBrandModal}
            options={options}
          />
        </Form.Item>
      </Col>
    </FormModal>
  );
};
